export default "__VITE_ASSET__DDW4TeHu__"